import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const LIST: AppRouteRecordRaw = {
  path: '/system', // 系统
  name: 'system',
  permission: 'system',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: 'menu.system',
    requiresAuth: true,
    icon: 'icon-settings',
    order: 7,
    permission: 'system',
  },
  children: [
    {
      path: 'userManage', // The midline path complies with SEO specifications
      name: 'userManage',
      permission: 'system:user',
      component: () => import('@/views/system/user/index.vue'),
      meta: {
        locale: 'menu.userManage',
        requiresAuth: true,
        roles: ['*'],
        permission: 'system:user',
      },
    },
    // {
    //   path: 'appManage', // The midline path complies with SEO specifications
    //   name: 'appManage',
    //   component: () => import('@/views/system/app/index.vue'),
    //   meta: {
    //     locale: 'menu.appManage',
    //     requiresAuth: true,
    //     roles: ['*'],
    //   },
    // },
    {
      path: 'roleManage',
      name: 'roleManage',
      permission: 'system:role',
      component: () => import('@/views/system/role/index.vue'),
      meta: {
        locale: 'menu.roleManage',
        requiresAuth: true,
        roles: ['*'],
        permission: 'system:role',
      },
    },
    {
      path: 'permissionManage',
      name: 'permissionManage',
      permission: 'system:permission',
      component: () => import('@/views/system/permission/index.vue'),
      meta: {
        locale: 'menu.permissionManage',
        requiresAuth: true,
        roles: ['*'],
        permission: 'system:permission',
      },
    },
    {
      path: 'operationLog',
      name: 'operationLog',
      permission: 'system:log',
      component: () => import('@/views/system/operationLog/index.vue'),
      meta: {
        locale: 'menu.operationLog',
        requiresAuth: true,
        roles: ['*'],
        permission: 'system:log',
      },
    },
    // {
    //   path: 'loginRecord',
    //   name: 'loginRecord',
    //   permission: 'system:login',
    //   component: () => import('@/views/system/loginRecord/index.vue'),
    //   meta: {
    //     locale: 'menu.loginRecord',
    //     requiresAuth: true,
    //     roles: ['*'],
    //     permission: 'system:login',
    //   },
    // },
    // {
    //   path: 'serviceManage', // The midline path complies with SEO specifications
    //   name: 'serviceManage',
    //   permission: 'sys:config',
    //   component: () => import('@/views/system/service/index.vue'),
    //   meta: {
    //     locale: 'menu.serviceManage',
    //     requiresAuth: true,
    //     roles: ['*'],
    //     permission: 'sys:config',
    //   },
    // },
  ],
};

export default LIST;
